import { render, staticRenderFns } from "./pastClaimModal.vue?vue&type=template&id=fc4d9b10&"
import script from "./pastClaimModal.vue?vue&type=script&lang=js&"
export * from "./pastClaimModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports